import React, { Component } from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { SiteEnum } from 'Common/FieldEnum';
import { ReactTableColumnProperties } from 'Common/Constants';
import { TrackedCheckbox } from 'Components';

import {
  getSiteItemsBySiteIds,
  emptySelectedItem,
} from '../../state/createedittruckroute/actions';

class SiteGrid extends Component {
  static propTypes = {
    allSitesData: PropTypes.array.isRequired,
    loadingAllSites: PropTypes.bool,
    getSiteItemsBySiteIds: PropTypes.func.isRequired,
    emptySelectedItem: PropTypes.func.isRequired,
    isNew: PropTypes.bool,
    id: PropTypes.string,
  };
  static defaultProps = {
    loadingAllSites: false,
    isNew: false,
    id: 0,
  };
  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        const filteredData = [];
        const checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[SiteEnum.Id]
            ? obj[SiteEnum.Id]
            : obj._original[SiteEnum.Id];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length && checkAllIds.length === dataObjs.length
            )}
            onChange={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: props => {
        const { original } = props;
        return (
          <div style={{ textAlign: 'center' }}>
            <TrackedCheckbox
              initialValue={
                this.props.initialSelectedSites.indexOf(
                  original[SiteEnum.Id]
                ) !== -1
              }
              checked={
                this.props.input.value.indexOf(original[SiteEnum.Id]) !== -1
              }
              onChange={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: SiteEnum.IsSelected,
      ...ReactTableColumnProperties,
      sortable: false,
      filterable: false,
    },
    {
      Header: 'Site Id',
      accessor: SiteEnum.Id,
      ...ReactTableColumnProperties,
    },
    {
      Header: () => {
        return (
          <span>
            Site
            <br />
            Description
          </span>
        );
      },
      visibilityName: 'Site Description',
      accessor: SiteEnum.Description,
      ...ReactTableColumnProperties,
    },
  ];

  rowInfo = {
    checked: false,
    original: null,
  };

  onFilteredChange = _.debounce(
    filtered => {
      const { getSiteItemsBySiteIds, id } = this.props;
      getSiteItemsBySiteIds({
        RouteId: id,
        SiteIds: this.getFilteredSelectedSites(),
      });
    },
    500,
    { leading: false }
  );

  handleHeaderLevelCheckBox = (data, checked, dataObjs) => {
    const {
      getSiteItemsBySiteIds,
      input,
      emptySelectedItem,
      isNew,
      id,
    } = this.props;
    const tableRows = [...input.value, ...data];
    const remove = [...tableRows];
    const checkedSites = [];
    _.forEach(dataObjs, obj => {
      const id = obj[SiteEnum.Id]
        ? obj[SiteEnum.Id]
        : obj._original[SiteEnum.Id];
      const index = remove.indexOf(id);
      if (index !== -1) {
        remove.splice(index, 1);
        checkedSites.push(id);
      }
    });
    if (checked) {
      this.props.input.onChange(tableRows);
      getSiteItemsBySiteIds({ RouteId: id, SiteIds: checkedSites });
      isNew && emptySelectedItem();
    } else {
      this.props.input.onChange(remove);
      getSiteItemsBySiteIds({ RouteId: id, SiteIds: [] });
      isNew && emptySelectedItem();
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const {
      input,
      getSiteItemsBySiteIds,
      emptySelectedItem,
      isNew,
      id,
    } = this.props;
    if (input && input.value) {
      const formValues = input.value.length ? [...input.value] : [];
      const index = formValues.indexOf(original[SiteEnum.Id]);
      if (checked && index === -1) {
        formValues.push(original[SiteEnum.Id]);
      } else if (index > -1) {
        formValues.splice(index, 1);
      }
      this.props.input.onChange(formValues);
      getSiteItemsBySiteIds({
        RouteId: id,
        SiteIds: this.getFilteredSelectedSites(formValues),
      });
      isNew && emptySelectedItem();
    }
  };
  getFilteredSelectedSites = formValues => {
    const { allSitesData, input, reactTableRef } = this.props;
    const checkedSiteOrders = [];
    const dataObjs =
      reactTableRef && reactTableRef.current
        ? reactTableRef.current.getResolvedState()
        : { sortedData: allSitesData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[SiteEnum.Id]
        ? obj[SiteEnum.Id]
        : obj._original[SiteEnum.Id];
      if (formValues) {
        formValues.indexOf(id) !== -1 && checkedSiteOrders.push(id);
      } else if (input.value.indexOf(id) !== -1) {
        checkedSiteOrders.push(id);
      }
    });
    return checkedSiteOrders;
  };

  render() {
    const { loadingAllSites, allSitesData } = this.props;
    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          defaultPageSize={20}
          loading={loadingAllSites}
          data={allSitesData}
          resizable={true}
          className={'-striped -highlight modalGrid'}
          defaultFilterMethod={caseInsensitiveFilter}
          columns={this.columns}
          noDataText={loadingAllSites ? '' : 'No sites found'}
          loadingText={loadingAllSites ? 'Loading...' : ''}
        />
      </Form.Field>
    );
  }
}

const mapDispatchToProps = {
  getSiteItemsBySiteIds,
  emptySelectedItem,
};

export const SiteGridContainer = connect(
  null,
  mapDispatchToProps
)(SiteGrid);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/createedittruckroute/SiteGridContainer.js